import type { ReactNode } from 'react';

import { PinnedSectionTextGroup } from '@/components/page-sections/pinned-section-text-group';
import { useShowPinnedSectionText } from '@/components/page-sections/use-show-pinned-section-text';

export function BlogPinnedChrome({
  pinnedHeading,
  pinnedDescription,
  children,
}: {
  pinnedHeading: string;
  pinnedDescription?: string;
  children: ReactNode;
}) {
  const showPinnedText = useShowPinnedSectionText(pinnedHeading, pinnedDescription);

  if (!showPinnedText) {
    return children;
  }

  return (
    <div className="space-y-4">
      <PinnedSectionTextGroup pinnedHeading={pinnedHeading} pinnedDescription={pinnedDescription} />
      {children}
    </div>
  );
}
